export default "__VITE_ASSET__10N3jFjH__"